import { registerEntityEndpoint as e } from "@editor/ui-utils";
var t = e("cta-button"), { getEntity: n, listEntities: r, putEntity: i, postEntity: a, deleteEntity: o } = t, s = async (e) => n(e), c = async (e) => a(e), l = async (e, t) => i(e, t), u = async (e) => o(e), d = () => ({
	label: "",
	link: "",
	description: "",
	layoutType: "primary",
	hasAffiliate: !1,
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	}
});
//#endregion
export { c as a, d as i, u as n, l as o, s as r, t };

//# sourceMappingURL=cta-button.service-x51NBJyi.js.map